import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
import "./AccessibilityMenu.css";

const AccessibilityMenu = ({ 
  visible, 
  onClose, 
  settings, 
  setSettings 
}) => {
  if (!visible) return null;

  return (
    <div className="accessibility-popup">
      <div className="acc-header">
        <span>Accessibility Tools</span>
        <button className="acc-close" onClick={onClose}>
          <FontAwesomeIcon icon={faXmark} />
        </button>
      </div>
      <hr />
      
      <div className="acc-body">
        <div className="acc-row">
          <label>High Contrast</label>
          <input 
            type="checkbox" 
            checked={settings.highContrast} 
            onChange={() => setSettings({ ...settings, highContrast: !settings.highContrast })} 
          />
        </div>

        <div className="acc-row">
          <label>Grayscale View</label>
          <input 
            type="checkbox" 
            checked={settings.grayscale} 
            onChange={() => setSettings({ ...settings, grayscale: !settings.grayscale })} 
          />
        </div>

        <div className="acc-row">
          <label>Text Size</label>
          <div className="font-stepper">
            <button onClick={() => setSettings({ ...settings, fontSize: Math.max(0.7, settings.fontSize - 0.1) })}>
              <FontAwesomeIcon icon={faMinus} />
            </button>
            <span>{Math.round(settings.fontSize * 100)}%</span>
            <button onClick={() => setSettings({ ...settings, fontSize: Math.min(1.5, settings.fontSize + 0.1) })}>
              <FontAwesomeIcon icon={faPlus} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccessibilityMenu;